<div class="fakebutton" [ngClass]="{'fly-buttn': showHistory}" (click)="showHistory = !showHistory">
  <div class="row align-items-center">
    <div class="col">
      <span>{{i18n.SIGNATURE.VER_ASSINANTES}}</span>
      &nbsp;<img src="../../../assets/icons/MOBILE/ic_arrow_drop_down_circle_24px.png" [ngClass]="{'upsidedown': showHistory}" class="mobile-btn-icon" alt="">
    </div>
  </div>
  <div class="row" *ngIf="showHistory">
    <div class="col">
      <div class="signer-list f-10">
        <div class="signer-item" *ngFor="let signer of signerList; let i = index" [ngClass]="{'bordered-signer-item': i !== signerList.length - 1}">
          
          <div class="row align-items-start">
            <div class="col-1">              
              <img class="h-8px" *ngIf="!signer.signed" src="../../../assets/icons/DESKTOP/ic_done_all_24px.png" alt="">
              <img class="h-8px" *ngIf="signer.signed" src="../../../assets/icons/DESKTOP/ic_done_all_-1.png" alt="">
            </div>
            <div class="col">
              <div class="row">                
                <div class="col">
                  <span class="f-8">{{signer.fullName}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="f-6">{{signer.email}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="f-6 f-opacited" *ngIf="!signer.signed">
                    {{i18n.SIGNATURE.PENDENTE}}
                  </span>
                  <span class="f-6 f-blue upper-case" *ngIf="signer.signed">
                    {{i18n.SIGNATURE.ASSINOU_COMO_UPERCASE}} {{signer?.type}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>